export default __webpack_public_path__ + "static/media/gallery17.16d2f647.jpg";